export enum ContentType {
    APPLICATION_JSON_CHARSET_UTF8 = 'application/json; charset=utf-8',
    TEXT_PLAIN_CHARSET_UTF8 = 'text/plain; charset=utf-8',
    MULTIPART_FORM_DATA = 'multipart/form-data'
}
